import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'Wypełniacz Algeness'}>
      <Helmet title={"Wypełniacz Algeness - Dent&Beauty | Świdnica"} />
    </OfferBase>
  )
}

export default Offer
